import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { createPinia, PiniaVuePlugin } from 'pinia'
// import axios from 'axios'


const pinia = createPinia()
Vue.config.productionTip = false
Vue.use(PiniaVuePlugin)
Vue.use(pinia)
// Vue.use(axios)

// axios.defaults.baseURL = "https://api.nextlevel.sd/api"
// axios.defaults.baseURL = "http://localhost:3333/api"
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
// axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
// window.$http = axios

new Vue({
  pinia,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
